import client from "src/services/client";
import { joinErrorMessages } from "src/services/helpers";
import { csvError, csvErrorData, errorMessage, loading, toastMessage, } from "src/store/store";
import Swal from "sweetalert2";
import moment from "moment";
import { navigate } from "svelte-routing";
export function resDataToArr(obj) {
    return Object.keys(obj).map((val) => {
        return {
            field: val,
            value: obj[val],
            required: true,
        };
    });
}
export function dynamicSort(property) {
    let sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        if (sortOrder == -1) {
            return b[property].localeCompare(a[property]);
        }
        else {
            return a[property].localeCompare(b[property]);
        }
    };
}
export function extractErrorMessage(error) {
    if (Array.isArray(error)) {
        errorMessage.set(error);
        return;
    }
    if (typeof error === "string") {
        errorMessage.set(`Error: ${error}`);
        return;
    }
    if (typeof error === "object") {
        const { response, message } = error;
        if (!response) {
            errorMessage.set(`Error: ${message}`);
            return;
        }
        const { data, status } = response;
        if (data === null || data === void 0 ? void 0 : data.data) {
            errorMessage.set(joinErrorMessages(data.data, (data === null || data === void 0 ? void 0 : data.code) || status));
        }
        else if (data === null || data === void 0 ? void 0 : data.errors) {
            errorMessage.set(joinErrorMessages(data.errors, (data === null || data === void 0 ? void 0 : data.status) || status));
        }
        else if (data === null || data === void 0 ? void 0 : data.message) {
            errorMessage.set(`Error ${(data === null || data === void 0 ? void 0 : data.code) || status} : ${data.message}`);
        }
        else if (data === null || data === void 0 ? void 0 : data.CaseNo) {
            errorMessage.set(`Error ${status} : ${data.CaseNo}`);
        }
        else {
            errorMessage.set(`Error ${status} : ${message}`);
        }
    }
}
export function handleCsvImport(e, url, service, dataCategory = "Data") {
    Swal.fire({
        title: `Do you want to upload this file <b class="link-text mt-2 fs-3">${e.target.files[0].name}</b>?`,
        showDenyButton: true,
        confirmButtonText: "<b>OK</b>",
        denyButtonText: `Don't upload`,
        confirmButtonColor: "#19F9B9",
        customClass: {
            confirmButton: "primary", //insert class here
        },
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            const dataArray = new FormData();
            dataArray.append("csvfile", e.target.files[0]);
            dataArray.append("File", e.target.files[0]);
            client(url, {
                method: "POST",
                version: service,
                header: "multipart",
                data: dataArray,
            })
                .then((res) => {
                var _a, _b, _c;
                if (((_b = (_a = res.data.data) === null || _a === void 0 ? void 0 : _a.rejects) === null || _b === void 0 ? void 0 : _b.length) === 0 ||
                    (res.data.totalSuccess &&
                        res.data.totalSuccess !== 0) ||
                    res.data.error_msg === "Success") {
                    Swal.fire({
                        icon: "success",
                        title: "Success!",
                        text: `${dataCategory} were succesfully imported`,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            globalThis.location.reload();
                        }
                    });
                    e.target.value = "";
                }
                else {
                    let error;
                    if ((_c = res.data.data) === null || _c === void 0 ? void 0 : _c.rejects) {
                        error = `${res.data.error_code}: `;
                        res.data.data.rejects.map((val) => {
                            return (error += `Line Number ${val.lineNumber}: ${val.errorMessage} \n`);
                        });
                    }
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: error || res.data.message,
                    });
                    e.target.value = "";
                    extractErrorMessage(error || res.data.message);
                }
            })
                .catch((err) => {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                });
                e.target.value = "";
                extractErrorMessage(err);
            });
        }
        else if (result.isDenied) {
            Swal.fire({
                text: "Changes are not saved",
                icon: "info",
                confirmButtonColor: "#19F9B9",
                customClass: {
                    confirmButton: "primary", //insert class here
                },
            });
            e.target.value = "";
        }
    });
}
export const renderDuration = (obj) => {
    let str = "";
    for (const key in obj) {
        const element = obj[key];
        if (element > 0) {
            str += `${element} ${key} `;
        }
    }
    return str;
};
export const renderBookingStatus = (int) => {
    let status = "";
    switch (int) {
        case 0:
            status = "Confirmed";
            break;
        case 1:
            status = "Ongoing";
            break;
        case 2:
            status = "Cancelled";
            break;
        case 3:
            status = "Cancelled (GetGO)";
            break;
        case 4:
            status = "Completed";
            break;
        case -1:
            status = "Pending";
    }
    return status;
};
export const splitCamelCaseAndCapitalize = (inputString = "") => {
    // Use a regular expression to split CamelCase and capitalize the first letter of each word
    if (typeof inputString === "string")
        return inputString
            .replace(/([a-z])([A-Z])/g, "$1 $2")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
};
//function to split imageUrls and get the folder + file name
export const splitImageUrl = (arr) => {
    // Handle undefined, null, or empty string
    if (!arr || typeof arr !== "string")
        return "";
    // Handle empty string after trim
    const trimmedUrl = arr.trim();
    if (!trimmedUrl)
        return "";
    const segments = trimmedUrl
        .split("/")
        .filter((segment) => segment.length > 0);
    // Remove common base segments that are not meaningful
    const baseSegmentsToSkip = [
        "http:",
        "https:",
        segments.find((s) => s.includes(".amazonaws.com")),
        segments.find((s) => s.includes(".s3")),
        segments.find((s) => s.includes("public")),
        "fms", // common prefix
    ].filter(Boolean);
    // Find the start index after skipping base segments
    let startIndex = 0;
    for (let i = 0; i < segments.length; i++) {
        const segment = segments[i];
        const shouldSkip = baseSegmentsToSkip.some((skipSegment) => segment === skipSegment ||
            segment.includes(".com") ||
            segment.includes(".amazonaws") ||
            segment === "fms");
        if (!shouldSkip) {
            startIndex = i;
            break;
        }
    }
    // Get meaningful segments (skip common infrastructure parts)
    const meaningfulSegments = segments.slice(startIndex);
    if (trimmedUrl.includes("/fms/jobs/") && meaningfulSegments.length >= 5) {
        return meaningfulSegments.slice(-5).join("/");
    }
    // If we have meaningful segments
    if (meaningfulSegments.length > 0) {
        // If it's a simple structure (only 2 segments: folder + filename), return just filename
        if (meaningfulSegments.length === 2) {
            return meaningfulSegments[meaningfulSegments.length - 1];
        }
        // If it's a complex structure (more than 2 segments), return full meaningful path
        else {
            return meaningfulSegments.join("/");
        }
    }
    // Fallback: return just the filename
    if (segments.length >= 1) {
        const filename = segments[segments.length - 1];
        return filename;
    }
    return "";
};
export const importCsv = async (e, url, service, close, refetch, emptyStore) => {
    var _a;
    // close to toggle modal
    // errorMsgHandler to show error in error modal
    try {
        loading.set(true);
        const dataArray = new FormData();
        dataArray.append("csvfile", e.target.files[0]);
        dataArray.append("File", e.target.files[0]);
        const res = await client(url, {
            method: "POST",
            version: service,
            header: "multipart",
            data: dataArray,
        });
        if (((_a = res.data.data) === null || _a === void 0 ? void 0 : _a.rejects.length) > 0) {
            csvErrorData.set(res.data.data.rejects);
            csvError.set(true);
        }
        else {
            refetch();
            toastMessage.set({
                message: "The CSV file has been uploaded successfully",
                type: "success",
            });
        }
        close();
        loading.set(false);
        refetch();
        emptyStore();
    }
    catch (error) {
        extractErrorMessage(error);
        console.log(error);
        loading.set(false);
    }
};
export function queryArrStrToNum(str) {
    if (!str)
        return [Number.NaN];
    return str.split(",").map(Number);
}
export function arrayToQueryParams(params) {
    let queryParams = {};
    Object.keys(params).forEach((key) => {
        if (Array.isArray(params[key])) {
            queryParams[key] = params[key].join(",");
        }
        else {
            queryParams[key] = params[key];
        }
    });
    return queryParams;
}
export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
export function lookupToOptions(items) {
    if (items)
        return items.map((item) => {
            return {
                id: item.id,
                label: item.substatus
                    ? item.status + " - " + item.substatus
                    : item.status ||
                        item.name ||
                        item.description ||
                        item.estateName,
                selected: false,
            };
        });
}
export function earliestBooking(start) {
    const now = new Date();
    const startDate = new Date(start);
    const diffMs = startDate.getTime() - now.getTime();
    if (diffMs <= 0) {
        return "Already started";
    }
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    if (diffDays > 0) {
        return `${diffDays} days from now`;
    }
    else if (diffHours > 0) {
        return `${diffHours} hours from now`;
    }
    else {
        return `${diffMinutes} minutes from now`;
    }
}
export function daysElapsed(createdAt) {
    const created = new Date(createdAt);
    const now = new Date();
    const diffMs = now.getTime() - created.getTime();
    // round down to nearest whole number
    return Math.floor(diffMs / (1000 * 60 * 60 * 24));
}
export function dateRange(start, end) {
    const startDate = moment(start);
    const endDate = moment(end);
    const startTime = startDate.format("HH:mm");
    const endTime = endDate.format("HH:mm");
    if (startDate.isSame(endDate, "day")) {
        return `${startDate.format("DD MMM YYYY")}, ${startTime} - ${endTime}`;
    }
    else {
        return `${startDate.format("DD MMM YYYY")}, ${startTime} - ${endDate.format("DD MMM YYYY")} ${endTime}`;
    }
}
export function scrollToTop() {
    const contentContainer = document.querySelector(".content-container");
    if (contentContainer) {
        contentContainer.scrollTo({ top: 0, behavior: "smooth" });
    }
}
export const separateSnakeCase = (str = "") => {
    // if str contains underscores, replace them with spaces
    if (str === null || str === void 0 ? void 0 : str.includes("_")) {
        return str.split("_").join(" ");
    }
    return str;
};
export const enumFinder = (options, value) => {
    const found = options.find((option) => option.value === value);
    return found ? found.label : value;
};
export function navigateToDetails(basePath, id) {
    const fullPath = `${basePath}${id}`;
    navigate(fullPath);
}
export function initializeDropdownOptions(options, initialSelectedIds) {
    return options.map((opt) => (Object.assign(Object.assign({}, opt), { selected: initialSelectedIds.includes(opt.id) })));
}
export function updateDropdownOptions(currentOptions, newSelectedIds) {
    return currentOptions.map((opt) => (Object.assign(Object.assign({}, opt), { selected: newSelectedIds.includes(opt.id) })));
}
export function getSelectedIds(dropdownOptions) {
    return dropdownOptions.filter((o) => o.selected).map((o) => o.id);
}
export const splitByComma = (arr = []) => {
    return arr
        .map((item) => item.split(","))
        .flat()
        .map((item) => item.trim())
        .filter((item) => item.length > 0)
        .join(", ");
};
export function updateCheckboxOptions(options, paramValue) {
    let selectedIds = [];
    if (paramValue) {
        if (Array.isArray(paramValue)) {
            selectedIds = paramValue.map((val) => typeof val === "number"
                ? val
                : isNaN(Number(val))
                    ? val
                    : Number(val));
        }
        else {
            selectedIds = paramValue
                .split(",")
                .map((val) => (isNaN(Number(val)) ? val : Number(val)));
        }
        return options.map((opt) => (Object.assign(Object.assign({}, opt), { selected: selectedIds.includes(opt.id) })));
    }
    else {
        return options.map((opt) => (Object.assign(Object.assign({}, opt), { selected: false })));
    }
}
export const carAssetOwnersDropdownCheckBoxOptions = (carAssetOwners = []) => {
    return carAssetOwners.map((option) => ({
        label: option.name,
        id: option.id,
        selected: false,
    }));
};
export function getOrDefault(value, defaultValue) {
    return value !== undefined ? value : defaultValue;
}
export function optionFinder(options, value) {
    const found = options.find((option) => option.value === value);
    return found || { value: value, label: value };
}
export function usePopstate(callback) {
    if (typeof globalThis !== "undefined") {
        const handler = () => callback();
        globalThis.addEventListener("popstate", handler);
        // Return a cleanup function
        return () => globalThis.removeEventListener("popstate", handler);
    }
    return () => { };
}
export const videoFileTypes = ["mp4", "mov", "avi", "wmv"];
export const isVideoFile = (filename) => {
    var _a;
    if (typeof filename === "object" && filename !== null) {
        filename =
            filename && typeof filename.name === "string" ? filename.name : "";
    }
    const extension = (_a = filename === null || filename === void 0 ? void 0 : filename.split(".").pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return extension ? videoFileTypes.includes(extension) : false;
};
export const fileContentChecker = (file) => {
    return typeof file === "object" ? URL.createObjectURL(file) : file;
};
export const CXTSRoles = ["CXCall", "CXEmail", "CXLiveChat", "TSSelfReported"];
export const isCXTSRole = (role) => {
    return CXTSRoles.includes(role);
};
export const phase3CaseOrigin = ["Operator", "FQ"];
export const isPhase3CaseOrigin = (origin) => {
    return phase3CaseOrigin.includes(origin);
};
export const isOperatorCaseOrigin = (originObj) => {
    return (originObj.caseOrigin === "Operator" ||
        originObj.createdFrom === "Operator");
};
export const isFQCaseOrigin = (originObj) => {
    return originObj.caseOrigin === "FQ" || originObj.createdFrom === "FQ";
};
